import React, { useEffect, useState } from 'react';
import PageBanner from '../components/PageBanner';
import { PackageCard } from '../components/Cards';
import { publicApi } from '../api/client';
import { Loader2 } from 'lucide-react';

const PackagesList = () => {
  const [pkgs, setPkgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.getPackages().then((d) => { setPkgs(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <>
      <PageBanner
        title="Egypt Tour Packages & Nile Cruise Deals"
        subtitle="All-inclusive Egypt journeys blending Cairo highlights, Nile cruises, Red Sea escapes and desert oases — curated by Egypt's most trusted specialists."
        image="https://images.unsplash.com/photo-1559738933-d69ac3ff674b?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: 'Packages' }]}
      />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="py-24 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {pkgs.map((p) => <PackageCard key={p.id} pkg={p} />)}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default PackagesList;
